import React, {useEffect, useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import AppConfig from '../../domain/AppConfig';
import AppService from '../../service/AppService';

const appConfig: AppConfig = AppService.appConfig();
import UserInfoForm from '../userInfo/UserInfoForm';

const SurveyUserInfo = React.forwardRef((props, ref) => {

  let {
    onLogin,
    viewer,
    readOnly,
  } = props;

  let userInfoFormRef = useRef(null);

  //TODO find away to avoid useImperativeHandle
  useImperativeHandle(ref, () => ({
    validate: () => {
      if (userInfoFormRef.current && viewer && viewer.isLogin) {
        return userInfoFormRef.current.validate();
      }
      return true; //return hasError=true if it is not login.
    }
  }));

  return (
    <>
      {viewer && !viewer.isLogin &&
      <iframe className="aperzaIframe" id="registerCookie"
              src={`${appConfig.aperzaIdHost}/modal/login/aperza-catalog/`}
              style={{width: '100%', height: '890px', border: 'none'}}/>

      }
      {viewer && viewer.isLogin &&
      <UserInfoForm ref={userInfoFormRef} viewer={viewer} readOnly={readOnly}/>
      }
    </>
  )

});

SurveyUserInfo.fragments = {
  viewer: gql`
      fragment SurveyUserInfo_viewer on Viewer {
          id
          ...UserInfoForm_viewer
      }
      ${UserInfoForm.fragments.viewer}
  `
};

SurveyUserInfo.propTypes = {
  onLogin: PropTypes.func,
};

export default SurveyUserInfo;
